(function () {
/*
* -----------------------------------------------------------------------------
* @cam/input-sizer
* -----------------------------------------------------------------------------
* @version 0.0.2
* @overview Input width from value.
* @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
* -----------------------------------------------------------------------------
*/ if (customElements.get("input-sizer") === undefined) {
    class InputSizer extends HTMLElement {
        constructor(){
            super();
            this.style.display = "contents";
            this.input = this.querySelector("input");
            if (!this.input) return;
            this.input.addEventListener("change", this.resize.bind(this));
            this.input.addEventListener("keydown", this.resize.bind(this));
            this.input.addEventListener("keyup", this.resize.bind(this));
        }
        resize() {
            this.input.style.width = this.input.value.length + "ch";
        }
    }
    customElements.define("input-sizer", InputSizer);
}



})();
